export default __webpack_public_path__ + "static/media/PDF.838f78db.svg";